import { Button, Icons } from "construct-ui";
import ViewBase from "../../view-base.view";
import 'CssFolder/schedule/jpo/jpo-calendar.scss';
import JPOScheduleCalendarWeekView from "./jpo-schedule-calendar-week.view";
import JPOScheduleCalendarDayView from "./jpo-schedule-calendar-day.view";


export default function JPOScheduleCalendarView() {

    const VIEW_TYPE = { DAY: 0, WEEK: 1 };
    let viewType = 0;
    ViewBase.call(this);




    return {
        oninit: ({ attrs }) => {

        },
        oncreate: function (vnode) {
            // onCreate();
        },
        view: (vnode) => {
            return [
                m('.jpo-calendar', [
                    m('div', { style: "display:flex" }, [
                        m('div', { style: "width:200px;" },
                            m('#viewType.btn-group.w-100[role="group"]',
                                {
                                    onchange: (e) => {
                                        viewType = parseInt(e.target.value);

                                    }
                                },
                                m('input#viewTypeOption1.btn-check[type="radio"][name="viewTypeOption"][autocomplete="off"]',
                                    {
                                        value: VIEW_TYPE.DAY,
                                        checked: viewType === VIEW_TYPE.DAY
                                    }
                                ),
                                m('label.btn.btn-outline-primary.w-50[for="viewTypeOption1"]', this.getText("LT00001021", "Day")),
                                m('input#viewTypeOption2.btn-check[type="radio"][name="viewTypeOption"][autocomplete="off"]',
                                    {
                                        value: VIEW_TYPE.WEEK,
                                        checked: viewType === VIEW_TYPE.WEEK
                                    }
                                ),
                                m('label.btn.btn-outline-primary.w-50[for="viewTypeOption2"]', this.getText("LT00000337", "Week")),
                            )
                        ),

                    ]),

                    viewType === VIEW_TYPE.DAY ?
                        m(JPOScheduleCalendarDayView, { colors: [vnode.attrs.color], userId: vnode.attrs.userId, scheduleDate: vnode.attrs.scheduleDate }) :
                        m(JPOScheduleCalendarWeekView, { userId: vnode.attrs.userId, scheduleDate: vnode.attrs.scheduleDate }),

                ]),
                this.getBaseViews()
            ];
        }
    }
}